import { Injectable, Inject } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { AppConfigService } from "./app-config.service";

@Injectable({
  providedIn: "root",
})
export class PoolService {
  constructor(
    // @Inject('apiUrl') private apiUrl:string,
    private http: HttpClient,
    private appConfig: AppConfigService,
  ) {}

  private get apiUrl(): string {
    return this.appConfig.apiUrl;
  }

  getPoolUsers(userName: any, type: any) {
    return this.http.get(
      this.apiUrl + "api/pool/user/" + userName + "/" + type,
    );
  }

  getPoolControlLisans() {
    console.log(this.apiUrl + "api/pool/lisans/control");
    return this.http.get(this.apiUrl + "api/pool/lisans/control");
  }

  poolSendPassword(obj: any) {
    console.log(this.apiUrl + "api/pool/sendpassword");
    // console.log(obj);
    return this.http.post(this.apiUrl + "api/pool/sendpassword", obj);
  }

  poolRepassword(obj: any) {
    console.log(this.apiUrl + "api/pool/repassword");
    //return this.http.post(this.apiUrl + 'api/pool/login', obj);
    return this.http.post(this.apiUrl + "api/pool/repassword  ", obj);
  }

  getPoolUserLimit(userName: string, type: string) {
    return this.http.get(
      this.apiUrl + "api/pool/user/limit/" + userName + "/" + type,
    );
  }

  getDashReports(userName: any) {
    return this.http.get(this.apiUrl + "api/pool/user/dashreports/" + userName);
  }

  executeDashReport(spname: any, company: any, userName: any) {
    return this.http.get(
      this.apiUrl +
        "api/pool/user/dashreports/execute/" +
        spname +
        "/" +
        company +
        "/" +
        userName,
    );
  }

  getDelegations(user: any, vekil: any) {
    if (vekil === null)
      return this.http.get(this.apiUrl + "api/pool/delegations/" + user);
    else
      return this.http.get(
        this.apiUrl + "api/pool/delegations/" + user + "/" + vekil,
      );
  }

  postDelegation(obj: any) {
    return this.http.post(this.apiUrl + "api/pool/delegations", obj);
  }

  deleteDelegation(id: any) {
    console.log(this.apiUrl + "api/pool/delegations/" + id);
    return this.http.delete(this.apiUrl + "api/pool/delegations/" + id);
  }

  getChiefs(amir: any) {
    console.log(this.apiUrl + "api/pool/chief/" + amir);
    return this.http.get(this.apiUrl + "api/pool/chief/" + amir);
  }

  getPerUpdateTypes(type: any) {
    console.log(this.apiUrl + "api/pool/update/" + type);
    return this.http.get(this.apiUrl + "api/pool/update/" + type);
  }

  getDocumentEmployee(user: any) {
    console.log(this.apiUrl + "api/pool/auth/doc/employee/" + user);
    return this.http.get(this.apiUrl + "api/pool/auth/doc/employee/" + user);
  }

  getDocumentSelect(user: any) {
    console.log(this.apiUrl + "api/pool/auth/doc/select/" + user);
    return this.http.get(this.apiUrl + "api/pool/auth/doc/select/" + user);
  }

  deleteDocument(idno: any) {
    console.log(this.apiUrl + "api/pool/auth/doc/delete/" + idno);
    return this.http.delete(this.apiUrl + "api/pool/auth/doc/delete/" + idno);
  }

  getPoolApproves(
    prmonayTuru?: any,
    type?: any,
    filterType?: any,
  ): Observable<any> {
    console.log(this.apiUrl + "api/pool/approves");
    const queryParams = new HttpParams()
      .set("companyId", JSON.parse(sessionStorage.getItem("companyid")!))
      .set("user", JSON.parse(sessionStorage.getItem("username")!))
      .set("rule", prmonayTuru != null ? prmonayTuru : "")
      .set("type", type != null ? type : "")
      .set("filterType", filterType != null ? filterType : "");
    return this.http.get(this.apiUrl + "api/pool/approves", {
      params: queryParams,
    });
  }

  remoteWorkDays(employeeId?: any, duration?: any): Observable<any> {
    console.log(this.apiUrl + "api/pool/approves/remoteWorkDays");
    const queryParams = new HttpParams()
      .set("companyId", JSON.parse(sessionStorage.getItem("companyid")!))
      .set("user", employeeId != null ? employeeId : 0)
      .set("duration", duration != null ? duration : 0);
    return this.http.get(this.apiUrl + "api/pool/approves/remoteWorkDays", {
      params: queryParams,
    });
  }

  fetchReport(
    employeeId?: any,
    startDate?: any,
    endDate?: any,
    flowType?: any,
  ): Observable<any> {
    console.log(this.apiUrl + "api/pool/fetchReport");
    const queryParams = new HttpParams()
      .set("companyId", JSON.parse(sessionStorage.getItem("companyid")!))
      .set("employeeId", employeeId != null ? employeeId : 0)
      .set("startDate", startDate)
      .set("endDate", endDate)
      .set("flowType", flowType);
    return this.http.get(this.apiUrl + "api/pool/fetchReport", {
      params: queryParams,
    });
  }

  dailySummary(
    employeeId?: any,
    startDate?: any,
    endDate?: any,
  ): Observable<any> {
    console.log(this.apiUrl + "api/pool/dailySummary");
    const queryParams = new HttpParams()
      .set("companyId", JSON.parse(sessionStorage.getItem("companyid")!))
      .set("employeeId", employeeId != null ? employeeId : 0)
      .set("startDate", startDate)
      .set("endDate", endDate);
    return this.http.get(this.apiUrl + "api/pool/dailySummary", {
      params: queryParams,
    });
  }

  addManual(obj: any) {
    console.log(this.apiUrl + "api/pool/addManual");
    //return this.http.post(this.apiUrl + 'api/pool/login', obj);
    return this.http.post(this.apiUrl + "api/pool/addManual", obj);
  }

  dailyLogs(employeeId?: any, date?: any): Observable<any> {
    console.log(this.apiUrl + "api/pool/dailyLogs");
    const queryParams = new HttpParams()
      .set("companyId", JSON.parse(sessionStorage.getItem("companyid")!))
      .set("employeeId", employeeId != null ? employeeId : 0)
      .set("date", date);
    return this.http.get(this.apiUrl + "api/pool/dailyLogs", {
      params: queryParams,
    });
  }

  postPoolApprove(obj: any) {
    return this.http.post(this.apiUrl + "api/pool/approves", obj);
  }

  putPoolApprove(obj: any) {
    return this.http.put(
      this.apiUrl + "api/pool/approves/" + obj.bcsApprove.id,
      obj,
    );
  }

  saveWeeklyShifts(obj: any) {
    console.log(this.apiUrl + "api/pool/saveWeeklyShifts");
    return this.http.post(this.apiUrl + "api/pool/saveWeeklyShifts", obj);
  }

  getWeeklyShifts(
    companyId: number,
    startDate: string,
    endDate: string,
  ): Observable<any> {
    const queryParams = new HttpParams()
      .set("companyId", JSON.parse(sessionStorage.getItem("companyid")!))
      .set("startDate", startDate)
      .set("endDate", endDate);
    return this.http.get(this.apiUrl + "api/pool/getWeeklyShifts", {
      params: queryParams,
    });
  }

  getActiveShiftWorkers(companyId: number): Observable<any> {
    const queryParams = new HttpParams().set(
      "companyId",
      JSON.parse(sessionStorage.getItem("companyid")!),
    );
    return this.http.get(this.apiUrl + "api/pool/getActiveShiftWorkers", {
      params: queryParams,
    });
  }

  getActiveShifts(companyId: number): Observable<any> {
    const queryParams = new HttpParams().set(
      "companyId",
      JSON.parse(sessionStorage.getItem("companyid")!),
    );
    return this.http.get(this.apiUrl + "api/pool/getActiveShifts", {
      params: queryParams,
    });
  }

  loadEmployeeDashboardData(): Observable<any> {
    const queryParams = new HttpParams()
      .set("companyId", JSON.parse(sessionStorage.getItem("companyid")!))
      .set("employeeId", JSON.parse(sessionStorage.getItem("userid")!));
    return this.http.get(this.apiUrl + "api/pool/getDashboard", {
      params: queryParams,
    });
  }

  getShifts(srkodu: any) {
    console.log(this.apiUrl + "api/pool/shifts/" + srkodu);
    return this.http.get(this.apiUrl + "api/pool/shifts/" + srkodu);
  }

  postPoolDailyMailApprove(obj: any) {
    console.log(this.apiUrl + "api/pool/approves/mail");
    return this.http.post(this.apiUrl + "api/pool/approves/mail", obj);
  }

  postPoolTimelyApprove(obj: any) {
    console.log(this.apiUrl + "api/pool/approves/timely");
    return this.http.post(this.apiUrl + "api/pool/approves/timely", obj);
  }

  postPoolFMApprove(obj: any) {
    console.log(this.apiUrl + "api/pool/approves/fm");
    return this.http.post(this.apiUrl + "api/pool/approves/fm", obj);
  }

  postPoolIOApprove(obj: any) {
    console.log(this.apiUrl + "api/pool/approves/io");
    return this.http.post(this.apiUrl + "api/pool/approves/io", obj);
  }

  postPoolPostaApprove(obj: any) {
    console.log(this.apiUrl + "api/pool/approves/posta");
    return this.http.post(this.apiUrl + "api/pool/approves/posta", obj);
  }

  postPoolRotaApprove(obj: any) {
    console.log(this.apiUrl + "api/pool/approves/rota");
    return this.http.post(this.apiUrl + "api/pool/approves/rota", obj);
  }

  postPoolPersonnelUpdateApprove(obj: any) {
    console.log(this.apiUrl + "api/pool/update");
    return this.http.post(this.apiUrl + "api/pool/update", obj);
  }

  postControlDemandInfo(obj: any) {
    console.log(this.apiUrl + "api/pool/approves/control");
    return this.http.post(this.apiUrl + "api/pool/approves/control", obj);
  }

  amrApprove(flowIndex: any, obj: any) {
    console.log(obj);
    console.log(this.apiUrl + "api/pool/approves/amrsubmit/" + flowIndex);
    return this.http.post(
      this.apiUrl + "api/pool/approves/amrsubmit/" + flowIndex,
      obj,
    );
  }

  getPoolShiftApprove(obj: any) {
    console.log(
      this.apiUrl +
        "api/pool/approves/shift/" +
        obj.date1 +
        "/" +
        obj.date2 +
        "/" +
        obj.username,
    );
    return this.http.get(
      this.apiUrl +
        "api/pool/approves/shift/" +
        obj.date1 +
        "/" +
        obj.date2 +
        "/" +
        obj.username,
    );
  }

  postPoolShiftApprove(obj: any) {
    console.log(this.apiUrl + "api/pool/approves/shift");
    return this.http.post(this.apiUrl + "api/pool/approves/shift", obj);
  }

  postPoolUser(obj: any) {
    console.log(this.apiUrl + "api/pool/user");
    return this.http.post(this.apiUrl + "api/pool/user", obj);
  }

  deletePoolUser(Id: any) {
    console.log(this.apiUrl + "api/pool/user");
    return this.http.delete(this.apiUrl + "api/pool/user/" + Id);
  }

  getPoolMacAdress() {
    console.log(this.apiUrl + "api/pool/machine");
    return this.http.get(this.apiUrl + "api/pool/machine");
  }

  getPoolCompanyLisans() {
    console.log(this.apiUrl + "api/pool/lisans");
    return this.http.get(this.apiUrl + "api/pool/lisans");
  }

  postPoolMacAdress(obj: any) {
    console.log(this.apiUrl + "api/pool/machine");
    return this.http.post(this.apiUrl + "api/pool/machine", obj);
  }

  getReport(obj: any) {
    console.log(this.apiUrl + "api/pool/reports");
    return this.http.post(this.apiUrl + "api/pool/reports", obj);
  }

  openReportUrl(url: any, obj: any) {
    return this.http.post(url, obj);
  }

  getTemplate(obj: any) {
    // console.log(obj);
    return this.http.post(this.apiUrl + "api/pool/forms", obj);
  }

  getDateCalculation(obj: any) {
    return this.http.post(this.apiUrl + "api/pool/dateCalculation", obj);
  }

  getReasons(type: any): Observable<any> {
    console.log(this.apiUrl + "api/pool/reasons");
    const queryParams = new HttpParams()
      .set("companyId", JSON.parse(sessionStorage.getItem("companyid")!))
      .set("user", JSON.parse(sessionStorage.getItem("username")!))
      .set("type", type);
    return this.http.get(this.apiUrl + "api/pool/reasons", {
      params: queryParams,
    });
  }

  getPosta() {
    console.log(this.apiUrl + "api/pool/postas");
    return this.http.get(this.apiUrl + "api/pool/postas");
  }

  getFMServices(user: any) {
    if (user === null)
      return this.http.get(this.apiUrl + "api/pool/fmservices");
    else return this.http.get(this.apiUrl + "api/pool/fmservices/" + user);
  }
}
